import { useEffect, useState, useMemo } from 'preact/hooks'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'
import Icon from 'snippets/icon/icon'

function NoticeGlobal() {
  const [type, setType] = useState('standard')
  const [content, setContent] = useState('')
  const [classCustom, setClassCustom] = useState('')
  const [isDisplayed, setIsDisplayed] = useState(false)

  useEffect(() => {
    globalEmitter.on(emitterProps.notice.global, (value) => {
      if (value.type) {
        setType(value.type)
      }

      if (value.content) {
        setContent(value.content)
      }

      setIsDisplayed(true)

      if (value.duration) {
        setTimeout(() => {
          setIsDisplayed(false)
        }, value.duration)
      } else {
        setTimeout(() => {
          setIsDisplayed(false)
        }, 5000)
      }

      if (value.classCustom) {
        setClassCustom(value.classCustom)
      }
    })
  }, [])

  const className = useMemo(() => {
    let classType = ''

    switch (type) {
      case 'success':
        classType = 'notice-main-success'
        break
      case 'error':
        classType = 'notice-main-error'
        break
      case 'warning':
        classType = 'notice-main-warning'
        break
    }

    return classType
  }, [type])

  return (
    <div className={`fixed left-0 right-0 bottom-20 z-[70] mx-auto flex max-w-96 justify-center ${classCustom}`}>
      <div className="text-center mx-4">
        {isDisplayed && (
          <div className={`notice-main inline-flex overflow-hidden ${className}`}>
            <div class="notice-main-vertical-line"></div>
            <button type="button" class="notice-main-icon" aria-label="icon notice">
              {type === 'success' && <Icon className="w-5 h-5 text-white" name="icon-success-circle" viewBox="0 0 20 20" />}
              {type === 'warning' && <Icon className="w-5 h-5 text-white" name="icon-info-circle-outline" viewBox="0 0 20 20" />}
              {type === 'standard' && <Icon className="w-5 h-5 text-white" name="icon-success-circle'" viewBox="0 0 20 20" />}
              {type === 'error' && <Icon className="w-5 h-5 text-white" name="icon-error-circle" viewBox="0 0 20 20" />}
            </button>
            <div class="notice-main-content bg-white">{content}</div>
          </div>
        )}
      </div>
    </div>
  )
}

export default NoticeGlobal
